import { Response } from 'modules/utils';
import { create } from 'modules/api';
import { Urls } from '../consts';
import { InsertQuestionnaireRequestData } from '../types';

export const insertQuestionnaireRequest = (
  body: InsertQuestionnaireRequestData,
): Promise<Response<unknown>> => create(Urls.INSERT_QUESTIONNAIRE, body);
